module.exports = "/fonts/NotoSansDisplay-SemiCondensedLightItalic.ttf?51fd01e54526dc791b3145e30cc73a00";